import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@@common';

import { ServiceConnectionClient } from '../../../api/api';
import useServiceConnectionMetadata from './useServiceConnectionMetadata';

/**
 * Resolves the iconName and iconUrl for a specific service connection instance by its ID.
 * Fetches the connection to obtain its type, then looks up the type's metadata.
 */
export default function useServiceConnectionIconById(id: string | undefined): { iconName: string | undefined; iconUrl: string | undefined } {
	const client = useApiClient(ServiceConnectionClient);
	const { serviceConnectionByName } = useServiceConnectionMetadata();

	const { data } = useQuery({
		queryKey: ['service-connection-type', id],
		queryFn: () => client.getById(id!, false),
		enabled: !!id,
		staleTime: 5 * 60 * 1000,
	});

	if (!data?.type) return { iconName: undefined, iconUrl: undefined };
	const meta = serviceConnectionByName.get(data.type);
	return { iconName: meta?.iconName, iconUrl: meta?.iconUrl };
}
